import Listing from "../Listing";
import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchlessonPhysicsgeometry } from "../../../redux/action/lessonsAction";
import SecureContent from "../../../components/secureContent";

const PhysicsAndGeoMetry = () => {
  const dispatch = useDispatch();
  const { physicsgeometryList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonPhysicsgeometry());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Physics, Geometry, and Robot Combat"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Physics, Geometry, and Robot Combat",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={physicsgeometryList} color={"#36296c"} />

        <Footer />
      </div>
    </>
  );
};

export default PhysicsAndGeoMetry;
